export default "__VITE_ASSET__C9XJ0ew5__"